var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiningData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92833 2.80042C3.99744 2.89804 5.48737 3.13606 6.96338 3.51438C8.45231 3.89602 9.86113 4.40404 10.8114 5.01454C11.523 5.47174 12.477 5.47175 13.1886 5.01454C14.1389 4.40404 15.5477 3.89602 17.0366 3.51439C18.5126 3.13607 20.0026 2.89804 21.0717 2.80042C21.1195 2.79606 21.1567 2.81065 21.1879 2.8407C21.2217 2.87324 21.25 2.92719 21.25 2.99898V18.0029C21.25 18.1305 21.1362 18.2895 20.931 18.3094C19.8152 18.4181 18.3011 18.6833 16.7831 19.157C15.2743 19.6279 13.7031 20.3228 12.5217 21.3218C12.2564 21.5461 11.7436 21.5461 11.4783 21.3218C10.2969 20.3228 8.72571 19.6279 7.21687 19.157C5.69887 18.6833 4.18482 18.4181 3.06904 18.3094C2.86623 18.2897 2.75 18.1301 2.75 18.0003V2.99831C2.75 2.92659 2.77822 2.87293 2.81183 2.84062C2.8429 2.81075 2.88012 2.79602 2.92833 2.80042Z",
    stroke: "#FFFCF1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V21",
    stroke: "#FFFCF1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9H9M5.5 12H7.5",
    stroke: "#FFFCF1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiningData);
export default __webpack_public_path__ + "static/media/MiningData.6e452d00.svg";
export { ForwardRef as ReactComponent };